(function () {
  const MOBILE_QUERY = '(max-width: 749px)';

  function initBlock(root) {
    const swiperEl = root.querySelector('.product-cards-row__swiper');
    if (!swiperEl) return;

    const gap = parseInt(getComputedStyle(root.querySelector('.product-cards-row')).getPropertyValue('--gap'), 10) || 12;
    let swiperInstance = null;
    const mql = window.matchMedia(MOBILE_QUERY);

    var wrapper = swiperEl.querySelector('.swiper-wrapper');

    function initSwiper() {
      if (swiperInstance || !window.Swiper) return;

      // Move non-element nodes (style tags, scripts) out of swiper-wrapper
      // so Swiper doesn't treat them as slides
      wrapper.querySelectorAll('style, script').forEach(function (node) {
        swiperEl.appendChild(node);
      });

      var slides = wrapper.children;
      if (slides.length === 0) return;

      Array.from(slides).forEach(function (slide) {
        slide.classList.add('swiper-slide');
      });

      var middleIndex = Math.floor(slides.length / 2);

      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: gap,
        speed: 300,
        centeredSlides: true,
        initialSlide: middleIndex,
        watchSlidesProgress: true,
        touchRatio: 1,
        threshold: 5,
        resistance: true,
        resistanceRatio: 0.85,
        allowTouchMove: true,
        grabCursor: true,
      });
    }

    function destroySwiper() {
      if (!swiperInstance) return;
      try {
        swiperInstance.destroy(true, true);
      } catch (e) {
        console.warn('Error destroying Swiper:', e);
      }
      swiperInstance = null;

      Array.from(wrapper.children).forEach(function (slide) {
        slide.classList.remove('swiper-slide');
      });
    }

    function handleBreakpoint(e) {
      if (e.matches) {
        initSwiper();
      } else {
        destroySwiper();
      }
    }

    mql.addEventListener('change', handleBreakpoint);
    if (mql.matches) initSwiper();

    return function cleanup() {
      mql.removeEventListener('change', handleBreakpoint);
      destroySwiper();
    };
  }

  function initAll() {
    const blocks = document.querySelectorAll('product-cards-row');
    blocks.forEach(function (block) {
      if (block.dataset.initialized === 'true') return;
      block.dataset.initialized = 'true';
      block._cleanup = initBlock(block);
    });
  }

  function init() {
    initAll();

    document.addEventListener('shopify:section:load', function () {
      setTimeout(initAll, 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
